/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Box, VStack, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { FiShield } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useTheme } from "../hooks/useTheme";

export default function NoAccess() {
  const { t } = useTranslation();
  const { isArabic, colors } = useTheme();

  const iconBgColor = useColorModeValue("rgba(239, 68, 68, 0.1)", "rgba(239, 68, 68, 0.1)");
  const iconColor = "#EF4444";

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH="70vh"
      bg={colors.bg}
    >
      <VStack spacing={6} textAlign="center" maxW="md" mx="auto" p={8}>
        <Box
          w="96px"
          h="96px"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg={iconBgColor}
        >
          <Icon as={FiShield} boxSize="48px" color={iconColor} />
        </Box>
        
        <Text fontSize="2xl" fontWeight="bold" color={colors.text}>
          {isArabic ? "غير مصرح بالوصول" : "Access Denied"}
        </Text>
        
        <Text fontSize="base" color={colors.subText}>
          {isArabic
            ? "ليس لديك صلاحية لعرض هذه الصفحة. يرجى الاتصال بالمسؤول."
            : "You don't have permission to view this page. Please contact the administrator."}
        </Text>
      </VStack>
    </Box>
  );
}

